import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Configuración de Hoprin+
export const firebaseConfig = {
    apiKey: "AIzaSyAagNJGOKbOXhqDJ6cv0E9mCHUJv0AjQA8",
    authDomain: "suite-gestion-hoprinplus.firebaseapp.com",
    projectId: "suite-gestion-hoprinplus",
    storageBucket: "suite-gestion-hoprinplus.firebasestorage.app",
    messagingSenderId: "231639303719",
    appId: "1:231639303719:web:670916b422b1f7eeef3002"
};

// Inicializar y EXPORTAR las variables clave
const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const auth = getAuth(app); // Importante: export const auth
